import { render, staticRenderFns } from "./CategoryBanner.vue?vue&type=template&id=730d7490&"
import script from "./CategoryBanner.vue?vue&type=script&lang=js&"
export * from "./CategoryBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports